const PREFIX = "meucontroleai:prize-game-played:"
const DAY_MS = 24 * 60 * 60 * 1000

function key(merchantId: string, gameId: string): string {
  return `${PREFIX}${merchantId}:${gameId}`
}

/** True when this device already drew in the game inside its period; showing the game alone never counts. */
export function prizeGamePlayedWithinPeriod(merchantId: string, game: { id: string; periodDays: number }, now = Date.now()): boolean {
  try {
    const at = Number(localStorage.getItem(key(merchantId, game.id)))
    return Number.isFinite(at) && at > 0 && now - at < Math.max(1, game.periodDays) * DAY_MS
  } catch {
    return false
  }
}

/** Consumes the period lock: called once the customer saw the result of a draw. */
export function markPrizeGamePlayed(merchantId: string, gameId: string, now = Date.now()): void {
  try {
    localStorage.setItem(key(merchantId, gameId), String(now))
  } catch {
    return
  }
}

const SEEN_PREFIX = "meucontroleai:prize-game-seen:"

/** True when the game already opened by itself on this device inside its period, so it never pops up again in that window. */
export function prizeGameAutoShownWithinPeriod(merchantId: string, game: { id: string; periodDays: number }, now = Date.now()): boolean {
  try {
    const at = Number(localStorage.getItem(`${SEEN_PREFIX}${merchantId}:${game.id}`))
    return Number.isFinite(at) && at > 0 && now - at < Math.max(1, game.periodDays) * DAY_MS
  } catch {
    return false
  }
}

/** Records that the game opened by itself on this device. */
export function markPrizeGameAutoShown(merchantId: string, gameId: string, now = Date.now()): void {
  try {
    localStorage.setItem(`${SEEN_PREFIX}${merchantId}:${gameId}`, String(now))
  } catch {
    return
  }
}

/** Whole days until the next chance, at least 1, or null when the date is missing or already past. */
export function daysUntilNextChance(nextChanceAt: string | undefined, now = Date.now()): number | null {
  const at = nextChanceAt ? Date.parse(nextChanceAt) : Number.NaN
  if (!Number.isFinite(at) || at <= now) return null
  return Math.max(1, Math.ceil((at - now) / DAY_MS))
}

/** "Próxima chance em N dias" for a future date, else null. */
export function nextChanceLabel(nextChanceAt: string | undefined, now = Date.now()): string | null {
  const days = daysUntilNextChance(nextChanceAt, now)
  if (days === null) return null
  return `Próxima chance em ${days} ${days === 1 ? "dia" : "dias"}`
}
